import React from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../../components/hooks/useTheme";
import { ViewRepairOrder } from "./ViewRepairOrder";


export const EditRepariOrder = () => {
  const { themeStyles } = useTheme();
  const idNumber = useLocation();


  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div>

          <ViewRepairOrder idNumber={idNumber} />

        </div>
      </div>
    </div>
  );
};
